import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-earnings-limitation',
  templateUrl: './earnings-limitation.component.html',
  styleUrls: ['./earnings-limitation.component.css']
})
export class EarningsLimitationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          const tabSecEl = Array.from(elArr[1].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          tabSecEl[0].style.marginRight = '5px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }
}
